import { DOCUMENT, inject, Service } from '@angular/core';
import { environment } from '@env';
import { WINDOW } from '@app/shared/injectors';

export interface LoginCredentials {
  email: string;
  password: string;
}

@Service()
export class AuthService {
  readonly #window = inject(WINDOW);
  readonly #document = inject(DOCUMENT);

  private readonly COOKIE_NAME = `goSession-${environment.name.slice(0, 3)}`;

  private hasSessionCookie(): boolean {
    if (typeof this.#document === 'undefined') return false;
    return this.#document.cookie?.includes(this.COOKIE_NAME) ?? false;
  }

  logout({ useReturnUrl }: { useReturnUrl: boolean }): void {
    const returnUrl = this.#window.location.pathname + this.#window.location.search;
    const hasReturnUrl = returnUrl && returnUrl.trim() !== '/';
    this.#window.location.href =
      useReturnUrl && hasReturnUrl
        ? `${environment?.apiUrl}/users/logout?from=ziggy&returnUrl=${returnUrl}`
        : `${environment?.apiUrl}/users/logout?from=ziggy`;
  }

  isAuthenticated(): boolean {
    return this.hasSessionCookie();
  }
}
